import moment from 'moment';
import { fromDateStr } from '../../../../../../helpers/utcDate';
import { fieldNames } from '../../MeterForm/constants';

export const getSerialNumber = (serialNumber) => {
  if (!serialNumber) return '';

  return ` №${serialNumber}`;
};

export const prepareValues = (values) => {
  const { actFile, files, ...otherValues } = values;

  const data = Object.entries(otherValues).reduce((acc, [key, value]) => {
    const val = typeof value === 'string' ? value.trim() : value;

    if (val) {
      acc[key] = moment.isMoment(val)
        ? fromDateStr(val)
        : key === fieldNames.verificationInterval
        ? Number(val)
        : val;
    }

    return acc;
  }, {});

  if (actFile?.length || files?.length) {
    const actArr =
      actFile
        ?.filter((file) => file.uid !== -1)
        .map((file) => ({ ...file, fileType: 'act' })) || [];
    const attachments =
      files?.map((file) => ({ ...file, fileType: 'file' })) || [];

    data.attachments = [...actArr, ...attachments];
  }

  return data;
};

export const base64StrToFile = (str, name) => {
  const arr = str.split(',');
  const mime = arr[0] ? arr[0].match(/:(.*?);/) : null;
  const bstr = atob(arr[arr.length - 1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], name, { type: mime ? mime[1] : '' });
};
